import { render, staticRenderFns } from "./DomainList.vue?vue&type=template&id=2841da68&"
import script from "./DomainList.vue?vue&type=script&lang=js&"
export * from "./DomainList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports